import { BellIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../hooks/useAuth';
import apiNet from '../../newApi/apiNet.ts';
import { IEpgDetailsState } from '../epg/EpgDetailsModal/IEpgDetailsState.ts';
import { AddReminderRequest } from '../../request/account/addReminderRequest.ts';
import DateHelper from '../../helpers/dateHelper.ts';
import dateHelper from '../../helpers/dateHelper.ts';
import { useAppSelector } from '../../stores/store.ts';
import { selectAccountReminderByTargetId } from '../account/reminder/accountRemindersSelectors.ts';

interface IProps {
    epgDetails: IEpgDetailsState;
}

export const ReminderButton = ({ epgDetails }: IProps) => {
    // const [isActive, setIsActive] = useState(false);
    const _authService = useAuth();
    const isReminder = useAppSelector(selectAccountReminderByTargetId(epgDetails.epgId.toString()));
    const nowTimestamp = dateHelper.DateTimeNowUnixTimestamp();
    if (nowTimestamp > epgDetails.startTimestamp) return;
    console.log(epgDetails.epgId);
    const createReminder = async () => {
        try {
            const newReminder: AddReminderRequest = {
                remindAt: DateHelper.DateTimeFromUnixTimestamp(epgDetails.startTimestamp),
                targetType: 'program_starting_soon',
                title: epgDetails.name,
                targetId: epgDetails.epgId.toString(),
            };
            await apiNet.addReminder(newReminder);
        } catch (e) {

        }
    };

    const deleteReminder = async () => {
        try {
            if (isReminder) {
                await apiNet.deleteReminder(isReminder.id);
            }
        } catch (e) {

        }
    };

    return (

        <>
            {_authService.token &&
                <button onClick={() => isReminder ? deleteReminder() : createReminder()}
                        className={` bg-neutral-800 ml-2 px-3 pr-4 py-2 transition-colors shrink-0 ring-offset-neutral-700 focus:outline-none focus:ring-offset-neutral-700 flex items-center border-0 border-red-500 rounded-full space-x-2 mb-2 cursor-pointer hover:bg-neutral-900`}>
                    <BellIcon
                        className={`relative shrink-0 w-5 h-5 text-neutral-100 ${isReminder ? 'fill-neutral-300' : 'fill-transparent'} transition-all duration-300`} />
                    <p className={`animate-opacityEaseIn`}>Przypomnij</p>
                </button>
            }
        </>
    );
};
